// extracted by mini-css-extract-plugin
export default {"container":"AdditionalInfo_container__8qO1w","row":"AdditionalInfo_row__opjC6"};